var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "80px",
    viewBox: "0 0 96 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personal-1-mixed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1170.000000, -1708.000000)",
    fillRule: "nonzero",
    id: "services"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.000000, 1552.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-4",
    transform: "translate(702.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(118.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9054726,18.9054726 L18.9054726,5.10194509 C18.9054726,3.9328454 17.986429,2.98507463 16.852765,2.98507463 L10.0129067,2.98507463 C8.87924264,2.98507463 7.960199,3.9328454 7.960199,5.10194509 L7.960199,18.9054726",
    id: "Path",
    fill: "#E5E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9353234,18.9054726 L12.9353234,2.98507463 L10.0147476,2.98507463 C8.88006685,2.98507463 7.960199,3.9328454 7.960199,5.10194509 L7.960199,18.9054726",
    id: "Path",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5223881,21.7215189 L95.5223881,73.2099331 C95.5223881,76.7400491 92.6839552,79.60199 89.1828358,79.60199 L6.33955224,79.60199 C2.83843284,79.60199 0,76.7400491 0,73.2099331 L0,21.7215189 C0,18.1914029 2.83843284,15.3294619 6.33955224,15.3294619 L18.875,15.3294619 C21.575,15.3294619 23.980597,13.6056005 24.8656716,11.0327882 L27.1796642,4.29874298 C28.0647388,1.72574252 30.4682836,0 33.1703358,0 L70.1505597,0 C72.8505597,0 75.2541045,1.72574252 76.1391791,4.29874298 L78.4550373,11.0327882 C79.3401119,13.6057886 81.7436567,15.3294619 84.4436567,15.3294619 L89.1826493,15.3294619 C92.6839552,15.3294619 95.5223881,18.1914029 95.5223881,21.7215189 Z",
    id: "Path",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#DAB413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1818954,79.5233268 L6.26739473,79.5233268 C2.80612547,79.5233268 0,76.6670421 0,73.1439031 L0,21.7572515 C0,18.2341125 2.80612547,15.3778278 6.26739473,15.3778278 L10.7925349,15.3778278 L10.7925349,15.3896555 C7.51238927,15.5956069 4.91450067,18.367596 4.91450067,21.7572515 L4.91450067,73.1439031 C4.91450067,76.6672299 7.72062614,79.5233268 11.1818954,79.5233268 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7071035,0.0786632873 C35.0359908,0.0786632873 32.659619,1.80099502 31.7846184,4.36891017 L29.496964,11.0896461 C28.6219634,13.6575613 26.2437471,15.3778278 23.5744788,15.3778278 L19.3691639,15.3778278 L19.3691639,15.3367127 C21.7435069,15.0620482 23.7864046,13.4279546 24.5822788,11.0896461 L26.8699333,4.36891017 C27.7449339,1.80099502 30.1211212,0.0786632873 32.7924184,0.0786632873 C32.7927873,0.0786632873 37.7071035,0.0786632873 37.7071035,0.0786632873 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.5223881,32.8358209 L95.5223881,73.2250752 C95.5223881,76.7468287 92.6839552,79.60199 89.1828358,79.60199 L6.33955224,79.60199 C2.83843284,79.60199 0,76.7468287 0,73.2250752 L0,32.8358209 L95.5223881,32.8358209 Z",
    id: "Path",
    fill: "#6C6CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9452736,79.60199 L6.13476945,79.60199 C2.74674463,79.60199 0,76.7468172 0,73.2250496 L0,32.8358209 L4.81050418,32.8358209 L4.81050418,73.2252373 C4.81050418,76.7470049 7.55724881,79.60199 10.9452736,79.60199 Z",
    id: "Path",
    fill: "#4949B7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E5E9EA",
    cx: 48.2587065,
    cy: 47.2636816,
    r: 26.3681592
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6666667,46.7653193 C66.6666667,52.3321568 64.2612264,57.3363994 60.4308786,60.7977082 C57.0783328,63.826731 52.6381737,65.6716418 47.7621383,65.6716418 C42.8879915,65.6716418 38.4459438,63.8265421 35.093398,60.7975193 C31.2632391,57.338288 28.8557214,52.3319679 28.8557214,46.7651305 C28.8557214,41.198293 31.2632391,36.191973 35.093398,32.734819 C38.4461327,29.7037188 42.8879915,27.8606965 47.7621383,27.8606965 C52.6381737,27.8606965 57.0783328,29.7057962 60.4308786,32.734819 C64.2612264,36.1942392 66.6666667,41.1984818 66.6666667,46.7653193 Z",
    id: "Path",
    fill: "#566368"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.855721, 27.860697)",
    fill: "#6F7B7F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1537166,5.52190292 C36.0551697,9.44276627 37.8766465,14.6618054 37.6179597,19.79751 C32.5076794,20.0572956 27.3144771,18.2269449 23.413024,14.3060815 C19.5115709,10.3852182 17.6900941,5.16617905 17.9500911,0.0319794065 C23.0588739,-0.229311156 28.2522634,1.60122769 32.1537166,5.52190292 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3958623,23.3682929 C18.2973154,27.2891562 20.1187922,32.5081953 19.8601054,37.6438999 C14.7511354,37.9051905 9.55512536,36.0748397 5.65385942,32.1537883 C1.75240629,28.2329249 -0.0690704891,23.0110641 0.192236836,17.8781812 C5.30120684,17.6167026 10.4944091,19.4472414 14.3958623,23.3682929 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(27.860697, 26.865672)",
    fill: "#435054"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3974433,40.6234358 C9.15606228,40.6234358 0.0103878754,31.5199074 0.0103878754,20.3303299 C0.0103878754,9.14075246 9.15606228,0.0372240182 20.3974433,0.0372240182 C31.6388244,0.0372240182 40.7844988,9.14056446 40.7844988,20.3303299 C40.7844988,31.5200954 31.6388244,40.6234358 20.3974433,40.6234358 Z M20.3974433,2.98374946 C10.7882808,2.98374946 2.97055463,10.7654493 2.97055463,20.3303299 C2.97055463,29.8952106 10.7882808,37.6769104 20.3974433,37.6769104 C30.0066059,37.6769104 37.824332,29.8952106 37.824332,20.3303299 C37.824332,10.7654493 30.0066059,2.98374946 20.3974433,2.98374946 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3974433,12.7755462 C16.2124516,12.7755462 12.8076838,16.1646239 12.8076838,20.3305179 C12.8076838,24.4964119 16.2124516,27.8853016 20.3974433,27.8853016 C24.582435,27.8853016 27.9872029,24.4962239 27.9872029,20.3305179 C27.9872029,16.1648119 24.582435,12.7755462 20.3974433,12.7755462 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.454332,13.9303483 L68.9138272,13.9303483 C70.420348,13.9303483 71.641791,12.6372669 71.641791,11.0419477 L71.641791,7.86352493 C71.641791,6.26840277 70.4205341,4.97512438 68.9138272,4.97512438 L57.454332,4.97512438 C55.9478112,4.97512438 54.7263682,6.26820575 54.7263682,7.86352493 L54.7263682,11.0419477 C54.7263682,12.6370699 55.9478112,13.9303483 57.454332,13.9303483 Z",
    id: "Path",
    fill: "#E5E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4360832,15.920398 L56.9370511,15.920398 C54.6207383,15.920398 52.7363184,13.9489712 52.7363184,11.5257102 L52.7363184,8.37478728 C52.7363184,5.95152632 54.6207383,3.9800995 56.9370511,3.9800995 L68.4360832,3.9800995 C70.752396,3.9800995 72.6368159,5.95152632 72.6368159,8.37478728 L72.6368159,11.5259056 C72.6368159,13.9491665 70.7522093,15.920398 68.4360832,15.920398 Z M56.9370511,7.04174957 C56.2344082,7.04174957 55.6630324,7.63970215 55.6630324,8.37459193 L55.6630324,11.5257102 C55.6630324,12.2607954 56.2344082,12.8585526 56.9370511,12.8585526 L68.4360832,12.8585526 C69.1387261,12.8585526 69.7101019,12.2606 69.7101019,11.5257102 L69.7101019,8.37478728 C69.7101019,7.63970215 69.1385394,7.04194491 68.4360832,7.04194491 C68.4360832,7.04174957 56.9370511,7.04174957 56.9370511,7.04174957 Z",
    id: "Shape",
    fill: "#E29A4B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#566368",
    cx: 18.4079602,
    cy: 69.1542289,
    r: 5.47263682
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service-3.a324186e2cfcc11f1ad1ea2c0a4ffa55.svg";
export { ForwardRef as ReactComponent };